import { Reducer } from 'redux';
import { ExperimentsConfigState } from '../configs/types';
import { SIGN_OUT } from '../../../actions/authActions';
import { FETCH_EXPERIMENT_CONFIG_SUCCESS } from '../actions/experimentsConfigActions';

export const initialState: ExperimentsConfigState = {
  experiments: undefined,
  userGroupApi: undefined,
};

const googleOptimizeABTestReducer: Reducer = (
  state: ExperimentsConfigState = initialState,
  action: { type: string; payload?: any },
) => {
  let nextState = { ...state };

  switch (action.type) {
    case SIGN_OUT:
      nextState = { ...initialState };
      return nextState;

    case FETCH_EXPERIMENT_CONFIG_SUCCESS:
      nextState = {
        ...state,
        experiments: action.payload.experiments,
        userGroupApi: action.payload.userGroupApi,
      };
      return nextState;
    default:
      return nextState;
  }
};

export default googleOptimizeABTestReducer;
